export default __webpack_public_path__ + "static/media/ring.ae2fcb0d.PNG";